import { BaseButtonTheme, styles, variants } from '../BaseButtonStyles.css';
import { multiVariantStyles } from './BaseButtonVariants.css';
import './BaseButtonBaseTheme.css';

const BaseButtonStableTheme: BaseButtonTheme = {
  multiVariantStyles,
  variants,
  styles
};

export { BaseButtonStableTheme };
